<template>
    <div class="cooperation">
       <div class="content">
          <div>
          <!-- <baidu-map v-bind:style="mapStyle" class="bm-view" ak="浣犵殑鐧惧害鍦板浘ak" :center="center" :zoom="zoom" :scroll-wheel-zoom="true"
            @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
              <bm-view style="width: 100%; min-height:60vh;"></bm-view>
              <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
            </bm-marker>
            </baidu-map>-->
          <baidu-map v-bind:style="mapStyle" :center="center" :zoom="zoom" @ready="handler" @click="getClickInfo" :scroll-wheel-zoom='true'>
            <bm-view style="width: 100%; min-height:60vh;"></bm-view>
            <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"> </bm-marker>
          </baidu-map>
          <!-- <div style="width: 100%; min-height:60vh;">
            <div class="map-box map-top" id="ct_middle_industry"></div>
          </div> -->
        </div>
       </div>
        <foot></foot>
    </div>
</template>
<script>
import {BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker} from 'vue-baidu-map'
import foot from '../components/foot'
export default {
  data() {
    return {
      showMapComponent: this.value,
        keyword: '',
        mapStyle: {
          width: '100%',
          height: this.mapHeight + 'px'
        },
        center: {lng:117.281419, lat: 34.217344},
        zoom: 15,
        companyMarkerTimer: null,
        companyMarkerBaseLat: 34.212880
    }
  },
  watch: {
    value: function (currentValue) {
      this.showMapComponent = currentValue
      if (currentValue) {
        this.keyword = ''
      }
    }
  },
  mounted() {
    window.scrollTo({ left: 0, top: 0 })
    //  const that = this
    //    that.initMap()
  },
  beforeDestroy() {
    if (this.companyMarkerTimer) {
      clearInterval(this.companyMarkerTimer)
      this.companyMarkerTimer = null
    }
  },
  components: {
    foot,
    BaiduMap,
    BmControl,
    BmView,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker
  },
  methods: {
    initMap() {
        const that = this
        that.TMap = new T.Map('ct_middle_industry')
        that.TMap.centerAndZoom(new T.LngLat(117.269120,34.212880), 18)
        // that.TMap.setStyle('indigo')
          that.drawMapPoints()
      },

      drawMapPoints() {
        this.drawCompanyPoints()
      },
      drawCompanyPoints() {
        const that = this
        let lngLat = new T.LngLat(117.269120, that.companyMarkerBaseLat)
        let icon = new T.Icon({
          iconUrl: require('../img/dw.png'),
          iconSize: new T.Point(30, 30),
        })
        let marker = new T.Marker(lngLat, { icon: icon })
        this.TMap.addOverLay(marker)

        if (that.companyMarkerTimer) {
          clearInterval(that.companyMarkerTimer)
        }

        let step = 0
        that.companyMarkerTimer = setInterval(() => {
          step += 0.25
          const offset = Math.sin(step) * 0.00001
          marker.setLngLat(new T.LngLat(117.269120, that.companyMarkerBaseLat + offset))
        }, 50)
      },
    //  getClickInfo (e) {
    //     this.center.lng = e.point.lng
    //     this.center.lat = e.point.lat
    //   },
    //   syncCenterAndZoom (e) {
    //     const {lng, lat} = e.target.getCenter()
    //     this.center.lng = lng
    //     this.center.lat = lat
    //     this.zoom = e.target.getZoom()
    //   },

      // handler ({BMap, map}) {
      //     // var point = new BMap.Point(117.293274, 34.215033)
      //     // map.centerAndZoom(point, 13)
      //     // var marker = new BMap.Marker(point) // 鍒涘缓鏍囨敞
      //     // map.addOverlay(marker) // 灏嗘爣娉ㄦ坊鍔犲埌鍦板浘涓?
      //     // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      //     // map.addOverlay(circle)
      //   },
        getClickInfo (e) {
          this.center.lng = e.point.lng
          this.center.lat = e.point.lat
        }
  }
}
</script>
<style lang="less" scoped>
 .serachinput {
        width: 300px;
        box-sizing: border-box;
        padding: 9px;
        border: 1px solid #dddee1;
        line-height: 20px;
        font-size: 16px;
        height: 38px;
        color: #333;
        position: relative;
        border-radius: 4px;
        -webkit-box-shadow: #666 0px 0px 10px;
        -moz-box-shadow: #666 0px 0px 10px;
        box-shadow: #666 0px 0px 10px;
    }
.cooperation{
    height: 100%;
    position: relative;
    overflow: auto;
    padding-top:90px;
    .content{
        width:1200px;
        // height:658px;
        margin:30px auto;
        img{
            width:100%;
        }
    }
}

  .map-box {
    // width: 1200px;
    height: 500px;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/contactUs.vue